import React from 'react';
import { Route, Switch } from 'react-router-dom';

import PrivateRoute from '../PrivateRoute';
import ProtectedRoute from '../ProtectedRoute';
import CommonRoute from '../CommonRoute';
import Login from '../Login';
import ForgotPassword from '../ForgotPassword';
import ResetPassword from '../ResetPassword';
import BgvHome from '../Bgv';
import CompanyAdmin from '../CompanyAdmin';
import Candidates from '../CompanyAdmin/Candidates';
import ViewCandidate from '../CompanyAdmin/ViewCandidate';
import InsufficienciesNew from '../CompanyAdmin/InsufficienciesNew';
import ManageCategories from '../CompanyAdmin/ManageCategories';
import Profile from '../CompanyAdmin/Profile';
import Administrators from '../CompanyAdmin/Administrators';
import AdminCard from '../CompanyAdmin/Administrators/AdminCard';
import ChangePassword from '../CompanyAdmin/ChangePassword';
import Document from '../CompanyAdmin/Document';
import ManageTags from '../CompanyAdmin/ManageTags';
import BulkCandidate from '../CompanyAdmin/AddBulkCandidate';
import ExportExcel from '../CompanyAdmin/ExportExcel';
import ErrorComponent from '../../core-components/ErrorComponent';
import EmailPreferences from '../CompanyAdmin/Administrators/EmailPreferences';
import CreateCandidate from '../CompanyAdmin/CreateCandidate';
import AppConstants from '../../core-components/AppConstants';

import ViewBuyPackage from '../CompanyAdmin/ViewBuyPackage';
import PurchaseHistory from '../CompanyAdmin/Packages/Prepaid/PurchaseHistory';
import PurchaseDetails from '../CompanyAdmin/Packages/Prepaid/PurchaseHistory/PurchaseDetails';
import Credits from '../CompanyAdmin/Packages/Prepaid/Credits';
import ChargesApproval from '../CompanyAdmin/ChargesApproval';
import RenderLink from '../../core-components/RenderLink';
import RenderDocuments from '../../core-components/RenderDocuments';
import UnAuthorized from '../UnAuthorized';
import Integrations from '../CompanyAdmin/frontend-common/Integrations';
import Transactions from '../CompanyAdmin/Transactions';
import CompanySettings from '../CompanyAdmin/CompanySettings';
import securitySetting from '../../components/CompanyAdmin/frontend-common/SecuritySettings';
import LeverHome from '../CompanyAdmin/frontend-common/Integrations/Lever';
import RazorPayXHome from '../CompanyAdmin/frontend-common/Integrations/RazorPayX';
import GreenHouseHome from '../CompanyAdmin/frontend-common/Integrations/GreenHouse';
import CreditBuyPackagePage from '../../components/CompanyAdmin/frontend-common/CreditBuyPackagePage';
import Logout from '../Logout';
import PaymentRequest from '../PaymentRequest';
import WalletPackageSummary from '../CompanyAdmin/WalletPackageSummary';
import SuccessPaymentRequest from '../CompanyAdmin/frontend-common/CreditBuyPackagePage/RequestPayment/SuccessRequestPayment';
import OrderDetails from '../CompanyAdmin/Transactions/Components/OrderDetails';
import ZohoRecruit from '../CompanyAdmin/frontend-common/Integrations/ZohoRecruit';
import Recruitee from '../CompanyAdmin/frontend-common/Integrations/Recruitee';

export default () => {
  return (
    <Switch>
      <Route
        exact
        path={'/'}
        render={() => {
          window.open(`${AppConstants.phpURL}`, '_self');
        }}
      />
      <ProtectedRoute exact path={'/login'} component={Login} />
      <Route exact path={'/reset-password'} component={ResetPassword} />
      <CommonRoute exact path={'/forgot-password'} component={ForgotPassword} />
      <CommonRoute exact path={'/set-password'} component={ResetPassword} />
      <Route exact path={'/candidate/bgv'} component={BgvHome} />
      <PrivateRoute exact path={'/purchase/payment-request'} component={PaymentRequest} />
      <PrivateRoute exact path={'/purchase/payment-success'} component={SuccessPaymentRequest} />
      <PrivateRoute exact path={'/profile'} component={Profile} onlyAdmin={false} />
      <PrivateRoute
        exact
        path={'/manageCategories'}
        component={ManageCategories}
        onlyAdmin={true}
      />
      <PrivateRoute exact path={'/changePassword'} component={ChangePassword} onlyAdmin={false} />
      <PrivateRoute exact path={'/dashboard'} component={CompanyAdmin} onlyAdmin={false} />
      <PrivateRoute exact path={'/candidates'} component={Candidates} onlyAdmin={false} />
      <PrivateRoute exact path={'/approval'} component={ChargesApproval} onlyAdmin={true} />
      <PrivateRoute exact path={'/viewCandidate'} component={ViewCandidate} onlyAdmin={false} />
      {/** Purchase history route is commented as per the feature ADO-3138 */}
      {/* <PrivateRoute exact path={'/purchaseHistory'} component={PurchaseHistory} onlyAdmin={false} /> */}
      <PrivateRoute
        exact
        path={'/transactionDetails'}
        component={PurchaseDetails}
        onlyAdmin={true}
      />
      <PrivateRoute exact path={'/orderDetails'} component={OrderDetails} onlyAdmin={false} />
      /** Commenting out below route as per ADO-7669*/
      {/* <PrivateRoute
        exact
        path={'/insufficiencies'}
        component={InsufficienciesNew}
        onlyAdmin={false}
      /> */}
      <Route exact path={'/candidate/consent'} component={BgvHome} />
      <PrivateRoute exact path={'/myTeam'} component={Administrators} onlyAdmin={true} />
      /** Commenting out below routes as per ADO-7669*/
      {/* <PrivateRoute exact path={'/editUser'} component={AdminCard} onlyAdmin={true} /> */}
      {/* <PrivateRoute exact path={'/addUser'} component={AdminCard} onlyAdmin={true} /> */}
      <PrivateRoute exact path={'/manageTags'} component={ManageTags} onlyAdmin={true} />
      <PrivateRoute exact path={'/bulkCandidate'} component={BulkCandidate} onlyAdmin={false} />
      <PrivateRoute exact path={'/settings'} component={CompanySettings} onlyAdmin={true} />
      <PrivateRoute exact path={'/exportCases'} component={ExportExcel} onlyAdmin={false} />
      <PrivateRoute exact path={'/document'} component={Document} onlyAdmin={false} />
      <PrivateRoute exact path={'/company/bgv'} component={BgvHome} onlyAdmin={false} />
      <PrivateRoute
        exact
        path={'/candidate/create'}
        component={CreateCandidate}
        onlyAdmin={false}
      />
      <PrivateRoute
        exact
        path={'/emailPreferences'}
        component={EmailPreferences}
        onlyAdmin={true}
      />
      <PrivateRoute exact path={'/packages'} component={ViewBuyPackage} onlyAdmin={true} />
      <PrivateRoute exact path={'/buy'} component={CreditBuyPackagePage} onlyAdmin={true} />
      <PrivateRoute exact path={'/transaction/:transactionType'} component={Transactions} onlyAdmin={true} />
      <PrivateRoute exact path={'/transaction'} component={Transactions} onlyAdmin={true} />
      {/** Credit route is commented as per the feature ADO-3138 */}
      {/* <PrivateRoute exact path={'/credits'} component={Credits} onlyAdmin={true} /> */}
      {/* Needs to be improvised from the product level so commenting this for now*/}
      {/* <PrivateRoute exact path={'/invoices'} component={PostpaidInvoice} onlyAdmin={true} /> */}
      <PrivateRoute
        exact
        path={'/candidate/document'}
        component={RenderDocuments}
        onlyAdmin={false}
      />
      <PrivateRoute exact path={'/candidate/report'} component={RenderLink} onlyAdmin={false} />
      <PrivateRoute exact path='/candidate/resume' component={RenderLink} onlyAdmin={false} />
      <PrivateRoute exact path='/invoice' component={RenderLink} onlyAdmin={false} />
      <PrivateRoute exact path='/balance' component={WalletPackageSummary} onlyAdmin={true} />
      <PrivateRoute exact path='/proforma-invoice' component={RenderLink} onlyAdmin={false} />
      <PrivateRoute exact path='/logout' component={Logout} onlyAdmin={false} />
      <PrivateRoute
        exact
        path='/candidate/consent-letter'
        component={RenderLink}
        onlyAdmin={false}
      />
      {/* Integrations */}
      <PrivateRoute exact path={'/integrations'} component={Integrations} onlyAdmin={true} />
      <PrivateRoute exact path={'/integrations/lever'} component={LeverHome} onlyAdmin={true} />
      <PrivateRoute
        exact
        path={'/integrations/razorpay'}
        component={RazorPayXHome}
        onlyAdmin={true}
      />
      <PrivateRoute
        exact
        path={'/integrations/greenhouse'}
        component={GreenHouseHome}
        onlyAdmin={true}
      />
      <PrivateRoute
        exact
        path={'/integrations/zoho-recruit'}
        component={ZohoRecruit}
        onlyAdmin={true}
      />
      <PrivateRoute exact path={'/integrations/recruitee'} component={Recruitee} onlyAdmin={true} />
      {/* ------ */}
      <Route exact path={'/error'} component={ErrorComponent} onlyAdmin={false} />
      <PrivateRoute exact path={'/unauthorized'} component={UnAuthorized} onlyAdmin={false} />
      <ProtectedRoute path='*' component={Login} noMatchFound={true} />
      <PrivateRoute exact path='/company/security-settings' component={securitySetting} />
    </Switch>
  );
};
